/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'
export type ShiftPlannedHubReturnServiceBreakLocationFragment = {
  __typename?: 'ServiceBreakLocation'
  id: string
  name: string
  type: Types.ServiceBreakLocationType
  baseCapacity: {
    __typename?: 'ServiceBreakLocationBaseCapacity'
    concurrentBreaks: number
  }
}

export const ShiftPlannedHubReturnServiceBreakLocationFragmentDoc = gql`
    fragment shiftPlannedHubReturnServiceBreakLocation on ServiceBreakLocation {
  id
  name
  type
  baseCapacity {
    concurrentBreaks
  }
}
    `
